import { logger } from '@mail-core/logger';
import { getItemFromLocalStorage, setItemFromLocalStorage } from 'reactApp/appHelpers/localstorageHelpers';
import { store as reduxStore } from 'reactApp/store';

const GALLERY_STATUS_KEY_PREFIX = 'vigbo_gallery_status_';

export const checkGalleryPublished = async (albumId: string): Promise<boolean> => {
    const storageKey = `${GALLERY_STATUS_KEY_PREFIX}${albumId}`;
    const cachedStatus = reduxStore.dispatch(getItemFromLocalStorage(storageKey));

    if (cachedStatus) {
        return cachedStatus === 'published';
    }

    try {
        const response = await fetch(`https://gallery.photo/api/v1/galleries/link-by-mail-ru-cloud-id/${albumId}`);

        if (response.status === 200) {
            reduxStore.dispatch(setItemFromLocalStorage(storageKey, 'published'));
            return true;
        }

        // иначе не кэшируем результат
        return false;
    } catch (error) {
        logger.error(error);
        return false;
    }
};
